import { render } from "./EmployeeRegister.vue?vue&type=template&id=6ebe5b9e&scoped=true"
import script from "./EmployeeRegister.vue?vue&type=script&lang=js"
export * from "./EmployeeRegister.vue?vue&type=script&lang=js"

import "./EmployeeRegister.vue?vue&type=style&index=0&id=6ebe5b9e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ebe5b9e"]])

export default __exports__